import { create } from "zustand";

type State = {
  updateRequired: boolean;
};

type Actions = {
  setUpdateRequired: () => void;
};

export const useVersionGateState = create<State & Actions>()((set, get) => ({
  updateRequired: false,
  setUpdateRequired: () => {
    if (!get().updateRequired) {
      set({ updateRequired: true });
    }
  },
}));
